import { render, staticRenderFns } from "./MenuShortcutForm.vue?vue&type=template&id=2545b62c&scoped=true"
import script from "./MenuShortcutForm.vue?vue&type=script&lang=js"
export * from "./MenuShortcutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2545b62c",
  null
  
)

export default component.exports